/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import {REMOVE_REPLY_STORE_REQUEST, REMOVE_REPLY_STORE_SUCCESS, REMOVE_REPLY_STORE_FAILURE} from "../../types";

const DeleteReplyStoreAction = (id) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/reply-stores/${id}`
        },
        method: 'DELETE',
        headers: (headers()),
        types: [
            REMOVE_REPLY_STORE_REQUEST,
            {
                type: REMOVE_REPLY_STORE_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REMOVE_REPLY_STORE_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REMOVE_REPLY_STORE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REMOVE_REPLY_STORE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {DeleteReplyStoreAction}